import { Button, Stack, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import { useQueryParams } from "../../shared/useQueryParams";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";

export const Failed: React.FC = () => {
  const { i18n } = useTranslation<{}>();

  const history = useHistory();
  const query = useQueryParams();
  const es = query.get("es");
  const en = query.get("en");
  const mi = query.get("mi");

  const goToMainPage = () => {
    history.push("/");
  };

  const errorMessage = useMemo(() => {
    if (i18n.language === "en-US" || i18n.language === "en") {
      return en;
    }
    if (i18n.language === "es") {
      return es;
    }
    return mi;
  }, [i18n.language, es, en, mi]);

  return (
    <Stack spacing={2} alignItems={"center"}>
      <Typography variant="h4">{t("paymentErrorMessage")}</Typography>
      {errorMessage && (
        <Typography variant="h5" fontWeight="bold">
          {t("errorReason", { errorMessage })}
        </Typography>
      )}
      <Button variant="contained" onClick={goToMainPage}>
        {t("backToHome")}
      </Button>
    </Stack>
  );
};
